import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.sort";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import iconsMixin from '../dtwin/state/bridge/iconsMixin';
import { get } from 'lodash';
export default {
  name: 'CoreDeviceTemplateEditDeviceInformation',
  mixins: [iconsMixin],
  props: {
    template: {
      type: Object,
      required: true
    },
    account: {
      type: String,
      default: null
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data: function data() {
    return {
      formValid: false,
      deviceBridgesForAccount: [],
      bridgeTypes: [],
      deviceBridgesLoading: false,
      selectedBridge: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    scopeDetailedName: function scopeDetailedName() {
      var name = get(this.template, 'scope.name');
      var id = get(this.template, 'scope.id') || get(this.template, 'scopeId');

      if (id !== undefined) {
        return "".concat(name, " (ID ").concat(id, ")");
      }

      return name;
    },
    bridgeCreateParameters: function bridgeCreateParameters() {
      var createDeviceMethod = get(this.bridgeConfig(this.selectedBridge), 'manifest.functionScope.extension.devices.create');
      return get(this.bridgeConfig(this.selectedBridge), "manifest.commands.instance.".concat(createDeviceMethod, ".parameters.data.properties")) || {};
    },
    bridgeCreateFields: function bridgeCreateFields() {
      var _this2 = this;

      var createParameters = this.bridgeCreateParameters || {};
      var keys = Object.keys(createParameters).filter(function (key) {
        var visibleConfig = get(createParameters, "[".concat(key, "].visible")) || {};
        return Object.keys(visibleConfig).every(function (dependentKey) {
          return _this2.template.deviceMeta.connectorData[dependentKey] === visibleConfig[dependentKey];
        });
      }).filter(function (k) {
        return createParameters[k].predefineInTemplates;
      });
      return keys.sort(function (a, b) {
        var orderIdxA = get(createParameters, "[".concat(a, "].orderIdx")) || 0;
        var orderIdxB = get(createParameters, "[".concat(b, "].orderIdx")) || 0;

        if (orderIdxA < orderIdxB) {
          return -1;
        }

        if (orderIdxA > orderIdxB) {
          return 1;
        }

        return a.localeCompare(b);
      });
    }
  }),
  watch: {
    'template.tenantId': function templateTenantId() {
      this.fetchBridges();
    },
    template: {
      handler: function handler() {
        if (!this.template) {
          return;
        }

        this.$emit('formValidated', this.formValid);
      },
      deep: true
    },
    formValid: function formValid() {
      this.$emit('formValidated', this.formValid);
    }
  },
  mounted: function mounted() {
    this.fetchBridges();
  },
  methods: {
    get: get,
    parentSelectorFilter: function parentSelectorFilter(item, parentList) {
      var _this3 = this;

      if (!this.template) {
        return;
      }

      return item.tenantId === this.template.tenantId && item.id !== this.template.id && parentList.findIndex(function (t) {
        return t.id === _this3.template.id;
      }) === -1;
    },
    setTags: function setTags(tags) {
      this.template.deviceMeta.tags = tags;
    },
    setGroups: function setGroups(a) {
      this.template.deviceMeta.groups = a.groups;
    },
    restrictCharacters: function restrictCharacters(event) {
      if (event.key === ',' || event.key === ';') {
        event.preventDefault();
      }
    },
    fetchBridges: function fetchBridges() {
      var _this4 = this;

      this.selectedBridge = null;
      this.deviceBridgesForAccount = [];

      if (!this.template || !this.template.tenantId) {
        return;
      }

      this.deviceBridgesLoading = true;
      Promise.all([ApiService.getBridgeTypes().then(function (bridgeTypes) {
        return bridgeTypes.filter(function (type) {
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
        });
      }), ApiService.getBridgesForTenant(this.template.tenantId)]).then(function (results) {
        _this4.bridgeTypes = results[0];
        var validDeviceBridges = results[1].filter(function (bridgeInstance) {
          var bridgeTypeDef = results[0].find(function (bridgeDef) {
            return bridgeDef.type === bridgeInstance.type;
          });

          if (get(bridgeTypeDef, 'manifest.functionScope.extension.devices.create') || get(bridgeTypeDef, 'manifest.functionScope.extension.devices.read')) {
            return true;
          }

          return false;
        });
        _this4.deviceBridgesForAccount = validDeviceBridges;
        _this4.selectedBridge = validDeviceBridges.find(function (bridge) {
          return bridge.id === _this4.template.deviceMeta.connectorId;
        });
        _this4.deviceBridgesLoading = false;
      }).catch(function (error) {
        _this4.deviceBridgesLoading = false;

        _this4.$snack(_this4.$i18n_t('Connectors.Connectors.errors.connectionError'), 'error');

        console.error('Error fetching bridges', error);
      });
    },
    bridgeConfig: function bridgeConfig(bridge) {
      if (!bridge) {
        return;
      }

      var foundMatch = this.bridgeTypes.find(function (config) {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    getDependsOnFieldValue: function getDependsOnFieldValue(createFields, currentField, deviceData) {
      var dependsOnFieldName = get(createFields[currentField], 'dependsOnField');

      if (!dependsOnFieldName) {
        return null;
      }

      return deviceData[dependsOnFieldName];
    }
  }
};